import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TrackOrder from "@/pages/TrackOrder";
import ParentProgress from "@/pages/ParentProgress";
import TeacherDashboard from "@/pages/TeacherDashboard";
import VerifyCertificate from "@/pages/VerifyCertificate";
import PrincipalDashboard from "@/pages/PrincipalDashboard";
import Leaderboard from "@/pages/Leaderboard";
import GetApp from "@/pages/GetApp";
import ChampionWall from "@/pages/ChampionWall";
import VirtualClassroom from "@/pages/VirtualClassroom";
import Layout from "@/components/Layout/Layout";
import Home from "@/pages/Home";
import DirectorVision from "@/pages/DirectorVision";
import Curriculum from "@/pages/Curriculum";
import SchoolPartnership from "@/pages/SchoolPartnership";
import StudentEnrollment from "@/pages/StudentEnrollment";
import LearnAndEarn from "@/pages/LearnAndEarn";
import Roboshop from "@/pages/Roboshop";
import ProjectsGallery from "@/pages/ProjectsGallery";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import RefundPolicy from "@/pages/RefundPolicy";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import StudentLogin from "@/pages/StudentLogin";
import StudentDashboard from "@/pages/StudentDashboard";
import VerifyId from "@/pages/VerifyId";
import VerifyStar from "@/pages/VerifyStar";
import AiotDiploma from "@/pages/AiotDiploma";
import AiotPortal from "@/pages/AiotPortal";
import AiotTest from "@/pages/AiotTest";
import AiotLab from "@/pages/AiotLab";
import SimranLive from "@/pages/SimranLive";
import SchoolBilling from "./pages/SchoolBilling";
import AmbassadorCertificate from "./pages/AmbassadorCertificate";
import RoboxAccount from "./pages/RoboxAccount";
import RobotLab from "./pages/RobotLab";
import RobotLabRun from "./pages/RobotLabRun";
import AdvancedCourses from "./pages/AdvancedCourses";
import CourseDetail from "./pages/CourseDetail";
import CourseLesson from "./pages/CourseLesson";
import MyProgress from "./pages/MyProgress";
import LabCertificate from "./pages/LabCertificate";
import VerifyLabCert from "@/pages/VerifyLabCert";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/vision" element={<DirectorVision />} />
              <Route path="/programs/:slug" element={<Curriculum />} />
              <Route path="/schools" element={<SchoolPartnership />} />
              <Route path="/enroll" element={<StudentEnrollment />} />
              <Route path="/learn-and-earn" element={<LearnAndEarn />} />
              <Route path="/roboshop" element={<Roboshop />} />
              <Route path="/projects" element={<ProjectsGallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/track-order" element={<TrackOrder />} />
              <Route path="/progress" element={<ParentProgress />} />
              <Route path="/teacher/login" element={<AdminLogin role="teacher" />} />
              <Route path="/teacher" element={<TeacherDashboard />} />
              <Route path="/verify-certificate" element={<VerifyCertificate />} />
              <Route path="/principal/login" element={<AdminLogin role="principal" />} />
              <Route path="/principal" element={<PrincipalDashboard />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/get-app" element={<GetApp />} />
              <Route path="/champions" element={<ChampionWall />} />
              <Route path="/virtual-classroom" element={<VirtualClassroom />} />
              <Route path="/student/login" element={<StudentLogin />} />
              <Route path="/student" element={<StudentDashboard />} />
              <Route path="/verify-id/:code" element={<VerifyId />} />
              <Route path="/verify-star/:code" element={<VerifyStar />} />
              <Route path="/courses/aiot-diploma" element={<AiotDiploma />} />
              <Route path="/courses/aiot-diploma/learn" element={<AiotPortal />} />
              <Route path="/courses/aiot-diploma/test/:week" element={<AiotTest />} />
              <Route path="/courses/aiot-diploma/lab/:lab" element={<AiotLab />} />
              <Route path="/verify-aiot/:code" element={<VerifyLabCert />} />
              <Route path="/simran-live" element={<SimranLive />} />
              <Route path="/school-billing/:token" element={<SchoolBilling />} />
              <Route path="/ambassador/:token" element={<AmbassadorCertificate />} />
              <Route path="/robox" element={<RoboxAccount />} />
              <Route path="/robot-lab" element={<RobotLab />} />
              <Route path="/robot-lab/certificate" element={<LabCertificate />} />
              <Route path="/my-progress" element={<MyProgress />} />
              <Route path="/robot-lab/:id" element={<RobotLabRun />} />
              <Route path="/advanced-courses" element={<AdvancedCourses />} />
              <Route path="/advanced-courses/:id" element={<CourseDetail />} />
              <Route path="/advanced-courses/:id/lesson" element={<CourseLesson />} />
            </Routes>
          </Layout>
          <Toaster richColors theme="light" position="top-right" />
        </BrowserRouter>
      </CartProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
